import React from "react";
import { noop } from "lodash";
import { bool, func, node } from "prop-types";

import ContactButtons from "src/shared/components/ContactButtons";
import {
  ASK_QUESTION,
  SCHEDULE_SHOWING
} from "src/shared/contact-boxes/experts/constants/formTypes";

const ExpertContactButtons = ({ children, isVertical, openContactForm }) => (
  <ContactButtons
    isVertical={isVertical}
    primaryClick={() => openContactForm(SCHEDULE_SHOWING)}
    primaryText="Schedule a showing"
    secondaryClick={() => openContactForm(ASK_QUESTION)}
    secondaryText="Ask a question"
  >
    {children}
  </ContactButtons>
);

ExpertContactButtons.propTypes = {
  children: node,
  isVertical: bool,
  openContactForm: func
};

ExpertContactButtons.defaultProps = {
  children: null,
  isVertical: false,
  openContactForm: noop
};

export default ExpertContactButtons;
